import styled from 'styled-components'

const StyledPostTagDrawer = styled.div`
  
`

export default StyledPostTagDrawer
